export default __webpack_public_path__ + "static/media/tutoria.41964064.png";